import { render, staticRenderFns } from "./CCDataSourceIcon.vue?vue&type=template&id=4f0b4bd1&scoped=true"
import script from "./CCDataSourceIcon.vue?vue&type=script&lang=js"
export * from "./CCDataSourceIcon.vue?vue&type=script&lang=js"
import style0 from "./CCDataSourceIcon.vue?vue&type=style&index=0&id=4f0b4bd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b4bd1",
  null
  
)

export default component.exports